module.exports = __webpack_public_path__ + "img/zones_img.bd1c28b1.svg";